import { alpha, css, styled } from "@mui/material";

export const TooltipHotkey = styled("kbd")(
    ({ theme }) => css`
        padding: 0px 4px;
        background: ${alpha(theme.palette.grey[800], 0.67)};
        border-radius: 2px;
    `,
);
